export const demoData = {
  version: 1.0,
  title: "Meeting Decisions Demo",
  flows: [
    {
      id: 0,
      sections: [
        {
          id: 0,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "0",
              x: "0",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["Decisions_Step0_Titlecard"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText: "",
        },
      ],
    },
    {
      id: 1,
      sections: [
        {
          id: 0,
          card: {
            transition: true,
            text: "Create and share a meeting agenda",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "0",
              x: "0",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: [""],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText: "",
        },
        {
          id: 1,
          card: {
            transition: false,
            text:
              "The Decisions meeting management solution built into Microsoft Teams transforms meeting culture by improving attendee preparation, collaboration, and engagement so you can have good discussions that lead to great decisions.",
            snack: {
              isVisible: true,
              position: "right",
            },
            position: {
              y: "72%",
              x: "50%",
            },
            beacon: {
              isVisible: false,
              position: "right",
            },
          },
          images: {
            name: ["Decisions_Step1_Image1"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "A Teams channel titled 'Marketing' is open. The icon bar on the left side of the screen vertically lists ten icons: Activity, Chat, Teams, Calendar, Calls, Files, Decisions, and an ellipsis. There are Apps and Help icons at the bottom.",
        },
        {
          id: 2,
          card: {
            transition: false,
            text: "Select a Teams channel to get started",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "69%",
              x: "7%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["Decisions_Step1_Image2"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "In the same view, a purple pop-up points to the channel “Go to Market Plan” under the header “Mark 8 Project Team” under “Your Teams.”",
        },
        {
          id: 3,
          card: {
            transition: false,
            text: "Navigate to the Meetings tab",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "6.5%",
              x: "46.5%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["Decisions_Step1_Image3"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "The Go To Market Plan channel now appears. A purple pop-up points to the tab at the top of the channel that reads “Meetings” next to the Posts, Files, and Wiki tabs.",
        },
        {
          id: 4,
          card: {
            transition: false,
            text: "Choose a meeting from the list to create an agenda",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "32%",
              x: "30.5%",
            },
            beacon: {
              isVisible: true,
              position: "bottom",
            },
          },
          images: {
            name: ["Decisions_Step1_Image4a"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "with a header that reads “March 2021.” Beneath the header is a list of meetings that include a date, time, meeting title, and a team name. A purple pop-up points to the second meeting in the list which is titled “Weekly GTM sync.”",
        },
        {
          id: 5,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "78%",
              x: "0",
            },
            beacon: {
              isVisible: false,
              position: "right",
            },
          },
          images: {
            name: ["Decisions_Step1_Image4b"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "After the user clicks the Weekly GTM sync meeting, its row is highlighted in blue.",
        },
        {
          id: 6,
          card: {
            transition: false,
            text: "Add an agenda item and description",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "43%",
              x: "29%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["Decisions_Step1_Image5a"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "In the same view, the user has typed 'Campaign assets' in the Title field.",
        },
        {
          id: 7,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "78%",
              x: "50%",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["Decisions_Step1_Image5a"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: true,
            sequenceSources: [
              "Decisions_Step1_Image5a",
              "Decisions_Step1_Image5b",
              "Decisions_Step1_Image5c",
              "Decisions_Step1_Image5d",
              "Decisions_Step1_Image5e",
              "Decisions_Step1_Image5f",
              "Decisions_Step1_Image6",
            ],
          },
          screenReaderText:
            "In the same view, the user has typed “Let’s review our asset checklist and assign actions” into the Description field.          ",
        },
        {
          id: 8,
          card: {
            transition: false,
            text:
              "Meeting organizers can also create and use custom templates to expedite the agenda creation process.",
            snack: {
              isVisible: true,
              position: "left",
            },
            position: {
              y: "83%",
              x: "50%",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["Decisions_Step1_Image6"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText: "",
        },
        {
          id: 9,
          card: {
            transition: false,
            text:
              "Upload relevant files for the agenda item by dragging and dropping into the box, or clicking the Upload files button",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "61%",
              x: "35%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["Decisions_Step1_Image7"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "In the same view, a purple pop-up points to the words “Drag files here or click” below the description field.",
        },
        {
          id: 10,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "35%",
              x: "38%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["Decisions_Step1_Image8"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "A File Explorer window appears including a row with a word document icon and the text “Mark 8 Proje...set checklist.” A purple pop-up highlights the word document title.",
        },
        {
          id: 11,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "75%",
              x: "80%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["Decisions_Step1_Image9"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "In the same view, a purple pop-up highlights a button that reads “Open” in File Explorer.",
        },
        {
          id: 11,
          card: {
            transition: false,
            text: "Add tags to categorize items by topic",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "66%",
              x: "30%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["Decisions_Step1_Image10"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "The File Explorer window disappears and the view returns to the Meetings tab in Teams with the Weekly GTM sync meeting opened. Below the Description field, a word document icon appears with text to the right that reads “Mark 8 Project Team campaign a...” A purple pop-up points to blue text that reads “Add tag” below the word document icon.",
        },
        {
          id: 12,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "50%",
              x: "50%",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["Decisions_Step1_Image11"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            " In the same view, the user clicks “Add tag” and types “marketing.” Beneath the text “marketing,” a drop down appears that reads “No type.”",
        },
        {
          id: 13,
          card: {
            transition: false,
            text:
              "Choose an agenda item type to help attendees better prepare for the meeting",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "69%",
              x: "30%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["Decisions_Step1_Image12"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "In the same view, a purple pop-up points to the drop down.",
        },
        {
          id: 14,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "71.4%",
              x: "29%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["Decisions_Step1_Image13"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "After the user clicks the drop down, the text “For Decision,” “For Discussion,” and “For Information” appears below “No Type.” A purple pop-up highlights the text “For Decision.”",
        },
        {
          id: 15,
          card: {
            transition: false,
            text: "Assign a presenter for the agenda item",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "41.6%",
              x: "92.5%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["Decisions_Step1_Image14"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "After the user selects For Decision,” a purple pop-up points to an icon with the outline of a person and a plus sign",
        },
        {
          id: 16,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "71%",
              x: "50.6%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["Decisions_Step1_Image15"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "After the user clicks the icon, a white rectangle appears with the header “1 Campaign assets.” Beneath the header there is text that reads “No presenter selected” and below that “Unassigned attendees.” Below that there is a search box that reads “Search or add by email” with a series of rows. The first row includes an icon of three people and reads “All,” and the five rows beneath that have profile pictures of team members along with their names, email, and the blue text “Owner” or “Member.” A purple pop-up highlights the profile picture of team member Alex Wilber.",
        },
        {
          id: 17,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "81.6%",
              x: "71%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["Decisions_Step1_Image16"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            " In the same view, a purple pop-up highlights a blue button below the row of profile pictures that reads “Apply.”",
        },
        {
          id: 18,
          card: {
            transition: false,
            text:
              "Meeting organizers can also assign external presenters, who will receive an invitation for their time slot on the agenda and will not have access to other agenda items to ensure meeting security.",
            snack: {
              isVisible: true,
              position: "left",
            },
            position: {
              y: "76%",
              x: "50%",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["Decisions_Step1_Image17"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "After the user clicks “Apply,” the view returns to the Meetings channel. The text “Alex Wilber” and Alex’s profile picture appear in the top right-hand corner of the white rectangle for the Campaign assets agenda item. ",
        },
        {
          id: 19,
          card: {
            transition: false,
            text: "Set the amount of time for the agenda item",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "40%",
              x: "30%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["Decisions_Step1_Image18"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "In the same view, a purple pop-up highlights blue text that reads “Time” next to a clock icon which sits above the “1 Campaign assets” header.",
        },
        {
          id: 20,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "45%",
              x: "30%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["Decisions_Step1_Image19"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "After the user clicks the Time icon, a field appears that reads “02:00 PM” with small boxes beneath it that list time intervals from 5 minutes to two hours. A purple pop-up highlights the box that reads “5 min.”",
        },
        {
          id: 21,
          card: {
            transition: false,
            text: "Press save to add the topic to the agenda",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "75%",
              x: "93%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["Decisions_Step1_Image20"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "In the same view, a purple pop-up highlights a blue button that reads “Save” that sits beneath the white rectangle for the Campaign asset agenda item.",
        },
        {
          id: 22,
          card: {
            transition: false,
            text:
              "Continue adding items to the agenda, following the same steps",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "80.5%",
              x: "56.3%",
            },
            beacon: {
              isVisible: false,
              position: "right",
            },
          },
          images: {
            name: ["Decisions_Step1_Image21"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "n the same view, a white button that reads “+ADD” appears outlined in a purple box.  ",
        },
        {
          id: 23,
          card: {
            transition: false,
            text:
              "Decisions will highlight the time in red if the allotted time exceeds the meeting length.",
            snack: {
              isVisible: true,
              position: "right",
            },
            position: {
              y: "83%",
              x: "83%",
            },
            beacon: {
              isVisible: false,
              position: "right",
            },
          },
          images: {
            name: ["Decisions_Step1_Image22"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "In the same view, more agenda items have been added. They include “1 Campaign assets” that read “2 Q2 GTM strategy check in,” and “3 GTM budget review.” A purple pop-up box outlines the third agenda item. ",
        },
        {
          id: 24,
          card: {
            transition: false,
            text:
              "Move items that will extend past the meeting to the next meeting by clicking the ellipsis and choosing Move to another meeting",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "44.7%",
              x: "93.3%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["Decisions_Step1_Image23"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "In the same view, a purple pop-up highlights the ellipsis in the bottom right-hand corner of the Campaign assets agenda item",
        },
        {
          id: 25,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "75.8%",
              x: "88%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["Decisions_Step1_Image24"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "After the user clicks the ellipsis, a drop-down appears with options that read “New task,” “New decision,” and more. A purple pop-up highlights the option that reads “Move to...”",
        },
        {
          id: 26,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "50%",
              x: "50%",
            },
            beacon: {
              isVisible: false,
              position: "right",
            },
          },
          images: {
            name: ["Decisions_Step1_Image25"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "After the user clicks “Move to...,” another drop down appears to the left of the current drop down with two options that read “Another meeting” and “Meeting Planner.” A purple rectangle outlines “Another meeting.”",
        },
        {
          id: 27,
          card: {
            transition: false,
            text:
              "Customize notifications about agenda updates for meeting participants by opening the notifications panel",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "38%",
              x: "85%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["Decisions_Step1_Image26"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "The drop-down collapses. An icon appears that reads “40%” and has a white circle around it filled with yellow that indicates 40% of the process has been completed. Two small boxes also appear which read “Minutes” and “My Notes” next to the Decisions and Tasks boxes. A narrow white rectangle appears below the boxes which reads “Attendees have not been notified about the agenda” with a button that reads “Open notification panel” highlighted in blue. A purple pop-up points to the Open notifications panel button.",
        },
        {
          id: 28,
          card: {
            transition: false,
            text:
              "Send the agenda to guest attendees, including employees outside of the team or individuals outside of the company via email and published to the Teams channel",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "56%",
              x: "80.7%",
            },
            beacon: {
              isVisible: false,
              position: "right",
            },
          },
          images: {
            name: ["Decisions_Step1_Image27"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "After the user clicks the Open notifications panel button, a white pop-up titled “Notify” appears on the right side of the screen outlined in a purple box .There are two tabs including Attendees and Guest Attendees, and the Attendees tab is underlined with a blue line. A form appears with options for how to message attendees and what to share with them, along with an empty “Message” field",
        },
        {
          id: 29,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "94.5%",
              x: "94.6%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["Decisions_Step1_Image28"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "In the same view, a purple pop-up highlights a blue button that reads “Notify” at the bottom of the white pop-up.",
        },
        {
          id: 30,
          card: {
            transition: false,
            text:
              "Once the agenda is complete, a card will appear in the Teams channel for attendees to view the agenda and suggest additional items.",
            snack: {
              isVisible: true,
              position: "right",
            },
            position: {
              y: "82%",
              x: "50%",
            },
            beacon: {
              isVisible: false,
              position: "right",
            },
          },
          images: {
            name: ["Decisions_Step1_Image29"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "In the same view, a purple pop-up points to the icon that indicates 40% of the process has been completed.",
        },
        {
          id: 31,
          card: {
            transition: false,
            text:
              "Click the Meeting Engagement Score for tips on how to improve team engagement and agenda quality",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "19.4%",
              x: "93.3%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["Decisions_Step1_Image30"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            " In the same view, a white pop-up appears from the bottom right-hand corner with the header “MEETING SCORE ANALYZER.” Beneath the header is a sub-header that reads “Team engagement” and has an icon that indicates the score is at 0%. There is another sub-header that reads “Agenda quality” and has an icon that indicates the score is at 100%.",
        },
        {
          id: 32,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "50%",
              x: "50%",
            },
            beacon: {
              isVisible: false,
              position: "right",
            },
          },
          images: {
            name: ["Decisions_Step1_Image31"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText: "",
        },
        {
          id: 33,
          card: {
            transition: false,
            text:
              "Use the button at the top of the agenda to launch Decisions integrations with other Microsoft Office products, including OneNote, Excel, Word, and Planner.",
            snack: {
              isVisible: true,
              position: "left",
            },
            position: {
              y: "78%",
              x: "50%",
            },
            beacon: {
              isVisible: false,
              position: "right",
            },
          },
          images: {
            name: ["Decisions_Step1_Image32"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "A purple box highlights the four multi-colored small boxes in the top right-hand corner.",
        },
      ],
    },
    {
      id: 2,
      sections: [
        {
          id: 0,
          card: {
            transition: true,
            text: "Review and collaborate on agendas",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "0",
              x: "0",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: [""],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "The Go to Market Plan channel in Teams is open with the Meetings tab highlighted.",
        },
        {
          id: 1,
          card: {
            transition: false,
            text:
              "With Decisions in Teams, attendees can better prepare for meetings by reviewing agendas and related documents ahead of time.",
            snack: {
              isVisible: true,
              position: "right",
            },
            position: {
              y: "81%",
              x: "50%",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["Decisions_Step2_Image1"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "The Go to Market Plan channel in Teams is open with the Meetings tab highlighted.",
        },
        {
          id: 2,
          card: {
            transition: false,
            text: "View the meeting agenda notification in the Teams channel",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "6.5%",
              x: "37.4%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["Decisions_Step2_Image2"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "In the same view, a purple pop-up points to the Posts tab.",
        },
        {
          id: 3,
          card: {
            transition: false,
            text: "Press the Agenda button to view the agenda",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "60%",
              x: "42.5%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["Decisions_Step2_Image3"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "The Posts tab is now open showing the Channel’s conversation. There are two posts from Megan Bowen. The second post starts with the text “Schedule a meeting” with a blue bar beneath it that has a calendar icon and the text “Weekly GTM sync” and “Occurs weekly Tuesday @2:00 pm.” Beneath the blue bar is a white rectangle with the header “Weekly GTM sync” with the date and time of the next occurrence with two buttons that read “Agenda” and “Suggest agenda items.” A purple pop-up highlights the Agenda button.",
        },
        {
          id: 4,
          card: {
            transition: false,
            text:
              "The agenda item labels – For Decision, For Discussion, and For Information – help guide attendees focus their preparation on the most important items.",
            snack: {
              isVisible: true,
              position: "right",
            },
            position: {
              y: "78%",
              x: "50%",
            },
            beacon: {
              isVisible: false,
              position: "right",
            },
          },
          images: {
            name: ["Decisions_Step2_Image4"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "A new view opens with the header “Weekly GTM sync” and the date and time of the meeting’s next occurrence. Below the header is a sub-header that reads “Agenda” and includes two white cards each with a title, time, description, tag, etc for an agenda item. In the second card there is a thumbnail of an Excel document titled “GTM budget.xlsx.”",
        },
        {
          id: 5,
          card: {
            transition: false,
            text: "Open attachments to review ahead of the meeting",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "45%",
              x: "12.2%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["Decisions_Step2_Image5"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "In the same view, a purple pop-up points to a pencil icon and down arrow next to the Excel document thumbnail.",
        },
        {
          id: 6,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "50%",
              x: "11%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["Decisions_Step2_Image6"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "After the user clicks the down arrow, a drop-down appears with options: Delete, Excel Online, and Annotate. A purple pop-up points to Excel Online.",
        },
        {
          id: 7,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "76%",
              x: "50%",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["Decisions_Step2_Image7"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "An Excel window appears showing the document GTM budget.",
        },
        {
          id: 8,
          card: {
            transition: false,
            text:
              "Meeting organizers can see the Meeting Engagement Score increase as participants view the agenda and attachments, helping to gauge preparation and inform where to start the conversation.",
            snack: {
              isVisible: true,
              position: "left",
            },
            position: {
              y: "74%",
              x: "50%",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["Decisions_Step2_Image8"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "The view returns to the Weekly GTM sync agenda view. The percent progress icon has updated to 85%.",
        },
        {
          id: 9,
          card: {
            transition: false,
            text: "Press the ellipses to leave a comment",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "51%",
              x: "49.9%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["Decisions_Step2_Image9"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            " A purple pop-up points to an ellipsis in the bottom right-hand corner of the GTM budget review agenda item card.",
        },
        {
          id: 10,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "70%",
              x: "5%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["Decisions_Step2_Image10a"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "A white rectangle appears below the agenda cards with the header Comments. Megan Bowen’s name and profile picture appear with a blue box beneath with a subject line and message field. At the bottom of the blue box are buttons that read 'Send' and “Cancel.” A purple pop-up points to the subject line field.",
        },
        {
          id: 11,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "72.5%",
              x: "4.8%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["Decisions_Step2_Image10a"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: true,
            sequenceSources: [
              "Decisions_Step2_Image10a",
              "Decisions_Step2_Image10b",
              "Decisions_Step2_Image10c",
              "Decisions_Step2_Image10d",
              "Decisions_Step2_Image10e",
            ],
          },
          screenReaderText:
            "In the same view, the user types “Thank you” in the subject line field. In the same view, the user types “It was so helpful to review this ahead of time!” in the message field.  In the same view, a purple pop-up highlights the Send button.",
        },
        {
          id: 12,
          card: {
            transition: false,
            text: "Upload files for agenda items",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "50.7%",
              x: "49.8%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["Decisions_Step2_Image12"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "After the user clicks send, the comment is posted. A purple pop-up points to the ellipsis in the bottom right-hand corner of the second agenda item.",
        },
        {
          id: 13,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "40%",
              x: "46%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["Decisions_Step2_Image13"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "After the user clicks the ellipsis, a drop down opens with eleven options including “New task,” “New decision,” and “My notes.” A purple pop-up points to the option “Upload file.”",
        },
        {
          id: 14,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "36.5%",
              x: "37.8%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["Decisions_Step2_Image14"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "A file explorer window opens and shows two documents. A purple pop-up points to an Excel document with the title “March GTM spending.”",
        },
        {
          id: 15,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "75%",
              x: "80%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["Decisions_Step2_Image15"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "After the user clicks the Excel document, its row is now highlighted in blue. A purple pop-up highlights the Open button at the bottom right-hand corner of the File Explorer window.",
        },
        {
          id: 16,
          card: {
            transition: false,
            text:
              "Presenters can individually upload and update documents for agenda items they own, saving time for meeting organizers.",
            snack: {
              isVisible: true,
              position: "left",
            },
            position: {
              y: "80%",
              x: "50%",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["Decisions_Step2_Image16"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "After the user clicks the Open button, the Agenda view returns. A thumbnail for the March GTM spending Excel document now appears next to the GTM budget Excel document thumbnail.",
        },
        {
          id: 17,
          card: {
            transition: false,
            text:
              "Suggest an agenda item by clicking the button in the Teams channel",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "60%",
              x: "50%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["Decisions_Step2_Image17"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "The view returns to the Posts tab. A purple pop-up points to the “Suggest agenda item” button beneath the text “Weekly GTM sync.”",
        },
        {
          id: 18,
          card: {
            transition: false,
            text:
              "Include relevant information, such as time, title, and description, and press save",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "35%",
              x: "26%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["Decisions_Step2_Image18a"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            " A white and grey rectangle pop-up appears with a blue “d” icon in the top right-hand corner along with a header “Decisions” and sub-header “Suggest and agenda item.” In the pop-up there is a form with a Time icon, Title field, Description field, “Add tag” button, and a drop-down that reads “No type.” There are two buttons at the bottom that read “Cancel” and “Suggest.” A purple pop-up points to the Title field.",
        },
        {
          id: 19,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "60%",
              x: "27%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["Decisions_Step2_Image18a"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: true,
            sequenceSources: [
              "Decisions_Step2_Image18a",
              "Decisions_Step2_Image18b",
              "Decisions_Step2_Image18c",
              "Decisions_Step2_Image19a",
              "Decisions_Step2_Image19b",
              "Decisions_Step2_Image19c",
              "Decisions_Step2_Image19d",
              "Decisions_Step2_Image20",
            ],
          },
          screenReaderText:
            "In the same view, the user types “March GTM spending” in the Title field.  In the same view, a purple pop-up points to the Description field. In the same view, the user types “If we have a few minutes I’d love to recap our March spending!” in the Description field. In the same view, a purple pop-up highlights the “Add tag” button.",
        },
        {
          id: 20,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "60%",
              x: "27%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["Decisions_Step2_Image21"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "After the user clicks “Add tag,” the words “Add tag” disappear and a blue check box appears to the right.",
        },
        {
          id: 21,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "69%",
              x: "74.3%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["Decisions_Step2_Image22"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "In the same view, the user types #marketing. A purple pop-up highlights the Suggest button.",
        },
        {
          id: 22,
          card: {
            transition: false,
            text:
              "Meeting organizers can review suggested agenda items and choose whether to add them the meeting or to a future one.",
            snack: {
              isVisible: true,
              position: "left",
            },
            position: {
              y: "80%",
              x: "50%",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["Decisions_Step2_Image23"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText: "The view returns to the Posts tab. ",
        },
      ],
    },
    {
      id: 3,
      sections: [
        {
          id: 0,
          card: {
            transition: true,
            text: "In-meeting extension",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "0",
              x: "0",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: [""],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText: "",
        },
        {
          id: 1,
          card: {
            transition: false,
            text:
              "The Decisions in-meeting extension features tools to keep attendees on track and engaged.",
            snack: {
              isVisible: true,
              position: "left",
            },
            position: {
              y: "83%",
              x: "50%",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["Decisions_Step3_Image1"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            " The Calendar icon of Teams is open under the Calendar tab which displays the user’s work week calendar. There is also a Bookings tab and buttons on the right that read “Meet now” and “New meeting.”",
        },
        {
          id: 2,
          card: {
            transition: false,
            text: "Join the Teams meeting",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "37%",
              x: "65%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["Decisions_Step3_Image2"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "In the same view, a white pop-up appears to the right of the meeting titled “Project Tailspin social campaigns.” The pop-up includes the meeting title, date, time, and buttons that read “Join” and “Edit.” There is also a link to join the meeting, a link to chat with participants, and the name of the organizer. A purple pop-up points to the Join button.",
        },
        {
          id: 3,
          card: {
            transition: false,
            text:
              "Open the Decisions in-meeting extension by pressing the icon in the Teams window",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "1.4%",
              x: "77%",
            },
            beacon: {
              isVisible: true,
              position: "top",
            },
          },
          images: {
            name: ["Decisions_Step3_Image3"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "After the user clicks the Join button, a Meeting view opens with a black screen and a profile picture in the middle. There are icons in the top right-hand corner including an icon with a lowercase d, representing the Decisions logo. A purple pop-up points to the Decisions icon in the upper right-hand corner",
        },
        {
          id: 4,
          card: {
            transition: false,
            text: "View the agenda item and description",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "21%",
              x: "85.6%",
            },
            beacon: {
              isVisible: false,
              position: "right",
            },
          },
          images: {
            name: ["Decisions_Step3_Image4"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "After the user clicks the Decision icon, a panel with a header that reads “Agenda” opens from the right-hand side. The panel includes two numbered agenda items each with a description including the time and a profile picture of the associated team member. A purple rectangle outlines the panel.",
        },
        {
          id: 5,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "19%",
              x: "85%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["Decisions_Step3_Image5"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "In the same view, a purple pop-up highlights the first agenda item titled “Paid ad strategy.”",
        },
        {
          id: 6,
          card: {
            transition: false,
            text:
              "The Decisions in-meeting extension features an easily visible time tracker for each agenda item, ensuring the meeting runs smoothly and that all important topics are covered.",
            snack: {
              isVisible: true,
              position: "left",
            },
            position: {
              y: "79%",
              x: "50%",
            },
            beacon: {
              isVisible: false,
              position: "right",
            },
          },
          images: {
            name: ["Decisions_Step3_Image6"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "After the user clicks the Paid ad strategy agenda item, the panel now shows more information about the agenda item including a tag and description. It includes two tabs that read “Details” and “Votes,” and the Details tab is currently open. A purple pop-up points to a left arrow next to the agenda item title.",
        },
        {
          id: 7,
          card: {
            transition: false,
            text:
              "Click on an attachment to open it while in the Teams meeting",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "31.2%",
              x: "100%",
            },
            beacon: {
              isVisible: false,
              position: "right",
            },
          },
          images: {
            name: ["Decisions_Step3_Image7"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "After the user clicks the left arrow, the view returns to the main Agenda panel view. A purple pop-up points to a paperclip icon with the number one, representing an attachment, underneath the second agenda item.",
        },
        {
          id: 8,
          card: {
            transition: false,
            text:
              "Users can access the Decisions add-in for Microsoft Word from the in-meeting extension to record meeting minutes in customizable templates.",
            snack: {
              isVisible: true,
              position: "right",
            },
            position: {
              y: "81%",
              x: "50%",
            },
            beacon: {
              isVisible: false,
              position: "right",
            },
          },
          images: {
            name: ["Decisions_Step3_Image8"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText: "",
        },
      ],
    },
    {
      id: 4,
      sections: [
        {
          id: 0,
          card: {
            transition: true,
            text: "Record decisions and tasks",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "0",
              x: "0",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: [""],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText: "",
        },
        {
          id: 1,
          card: {
            transition: false,
            text:
              "With the Decisions app in Teams, meeting participants can record  decisions made in meetings and assign tasks to create a shared view  of outcomes and action items.",
            snack: {
              isVisible: true,
              position: "left",
            },
            position: {
              y: "79%",
              x: "50%",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["Decisions_Step4_Image1"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "The Decisions app is open in Teams on the Decisions tab. The screen shows two tabs that read “Decision” and “About.” The Decisions tab view shows cards with upcoming meetings including dates and times. The second meeting card is titled “Weekly GTM Sync” and it includes the text “Mark 8 Project Team / Go to Market Plan” and an Agenda icon on the right side of the card.",
        },
        {
          id: 2,
          card: {
            transition: false,
            text: "Navigate to the meeting agenda view",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "34.6%",
              x: "42.5%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["Decisions_Step4_Image2"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText: "A purple pop-up highlights the Agenda icon.",
        },
        {
          id: 3,
          card: {
            transition: false,
            text: "Choose the agenda item where a decision was made",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "73%",
              x: "72.5%",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["Decisions_Step4_Image4"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "After the user clicks the Agenda icon, a new view appears with the header “Weekly GTM sync” and a list of agenda item cards. A purple box highlights the second agenda item card titled “GTM budget review.”",
        },
        {
          id: 4,
          card: {
            transition: false,
            text: "Click on the ellipses and select New decision",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "81.6%",
              x: "73.1%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["Decisions_Step4_Image5"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            " In the same view, a purple pop-up points to the ellipses in the bottom right-hand corner of the GTM budget review card.",
        },
        {
          id: 5,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "50.3%",
              x: "69.3%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["Decisions_Step4_Image6"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            " In the same view, a drop-down appears above the ellipses with eleven options including New Task and New Decision. A purple pop-up highlights the New Decision option.",
        },
        {
          id: 6,
          card: {
            transition: false,
            text: "Provide a title and description",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "37.5%",
              x: "32%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["Decisions_Step4_Image7a"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "After the user clicks the New Decision option, a white pop-up appears with a header that reads “New Decision.” The pop-up is a form with the drop-down titled “Agenda Item” and fields including “Title” and “Description.” “2-GTM budget review” is selected under the Agenda Item field. There is a toggle at the bottom of the pop-up which read “Proposed” and “Final,” as well as buttons that read “Cancel” and “Save.” A purple pop-up highlights the “Title” field.",
        },
        {
          id: 7,
          card: {
            transition: false,
            text: "Indicate if the decision is proposed or final",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "79.2%",
              x: "36.1%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["Decisions_Step4_Image7a"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: true,
            sequenceSources: [
              "Decisions_Step4_Image7a",
              "Decisions_Step4_Image7b",
              "Decisions_Step4_Image7c",
              "Decisions_Step4_Image8a",
              "Decisions_Step4_Image8b",
              "Decisions_Step4_Image8c",
              "Decisions_Step4_Image9",
            ],
          },
          screenReaderText:
            "In the same view, the user types “Sign off from finance” in the Title field. In the same view, a purple pop-up highlights the Description field. The user types “Q2 campaign budget looks great please submit to finance for review” in the Description field. In the same view, a purple pop-up highlights the toggle.",
        },
        {
          id: 8,
          card: {
            transition: false,
            text: "Press save to record the decision",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "84.6%",
              x: "69%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["Decisions_Step4_Image10"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "After the user changes the toggle to Final, a purple pop-up highlights the Save button.",
        },
        {
          id: 9,
          card: {
            transition: false,
            text:
              "View all meeting decisions by clicking the decision button at the top of the agenda",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "32.5%",
              x: "68.3%",
            },
            beacon: {
              isVisible: false,
              position: "bottom",
            },
          },
          images: {
            name: ["Decisions_Step4_Image11"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "After the user clicks the Save button, the view returns to the Agenda view. A purple box highlights a blue square box that reads “Decisions” and the number one.",
        },
        {
          id: 10,
          card: {
            transition: false,
            text: "Click on the ellipses and select New task",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "54.4%",
              x: "73.1%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["Decisions_Step4_Image12"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "In the same view, a purple pop-up highlights the ellipsis at the bottom right-hand corner of the top card.",
        },
        {
          id: 11,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "20.3%",
              x: "68%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["Decisions_Step4_Image13"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            " In the same view, a white drop-down appears above the ellipsis. A purple pop-up highlights the New task option.",
        },
        {
          id: 12,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "65.7%",
              x: "60.7%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["Decisions_Step4_Image14"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "A white pop-up appears with a header that reads 'Select a plan.” It also reads “Decisions uses Microsoft Planner to manage tasks and decisions” and below that “Create a new task plan.” A purple pop-up highlights the Save button in the bottom right-hand corner.",
        },
        {
          id: 13,
          card: {
            transition: false,
            text: "Enter a name and description for the task",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "20%",
              x: "79%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["Decisions_Step4_Image15"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "The white pop-up disappears and a white panel now appears from the right-hand side with a header that reads “Tasks.” There is a form with fields for the task name, description and more. A purple pop-up highlights the top field which reads “Enter a task name.”",
        },
        {
          id: 14,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "26%",
              x: "79%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["Decisions_Step4_Image16a"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "In the same view, the user types “Finalize GTM strategy.” A purple pop-up highlights the Description field.",
        },
        {
          id: 15,
          card: {
            transition: false,
            text: "Set a due date for the task",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "41%",
              x: "81.8%",
            },
            beacon: {
              isVisible: false,
              position: "right",
            },
          },
          images: {
            name: ["Decisions_Step4_Image16a"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: true,
            sequenceSources: [
              "Decisions_Step4_Image16a",
              "Decisions_Step4_Image16b",
              "Decisions_Step4_Image16c",
              "Decisions_Step4_Image16d",
              "Decisions_Step4_Image17",
            ],
          },
          screenReaderText:
            "In the same view, the user types “Review Q2 strategy based on team feedback and finalize” in the Description field. In the same view a purple pop-up box outlines the date 3/31/2021 which sits below the Description field.",
        },
        {
          id: 16,
          card: {
            transition: false,
            text: "Add team members who will be working on the task",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "43.5%",
              x: "78.6%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["Decisions_Step4_Image18"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "In the same view, a purple pop-up points to an icon with an outline of a person and a plus button which sits next to the text “Nestor Wilke” and a profile picture.",
        },
        {
          id: 17,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "47%",
              x: "80%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["Decisions_Step4_Image19"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "In the same view, a search bar appears with a list of profile pictures and names beneath it. The first name is Nestor Wilke and it’s listed under a header that reads “Assigned.” The rest of the names are listed under the header “Unassigned.” A purple pop-up highlights the search bar.",
        },
        {
          id: 18,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "64,5%",
              x: "79.1%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["Decisions_Step4_Image20"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText: "",
        },
        {
          id: 19,
          card: {
            transition: false,
            text: "Press Add to save",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "51%",
              x: "87%",
            },
            beacon: {
              isVisible: true,
              position: "top",
            },
          },
          images: {
            name: ["Decisions_Step4_Image21"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "After the user clicks Alex Wilber’s profile picture, the search bar disappears. Now Alex Wilber’s profile picture appears next to Nestor Wilke’s profile picture. A purple pop-up highlights a green button that reads “+ Add” beneath the profile pictures.",
        },
        {
          id: 20,
          card: {
            transition: false,
            text:
              "Tasks are powered by Microsoft Planner and can also be integrated with Power Apps.",
            snack: {
              isVisible: true,
              position: "left",
            },
            position: {
              y: "83%",
              x: "50%",
            },
            beacon: {
              isVisible: true,
              position: "top",
            },
          },
          images: {
            name: ["Decisions_Step4_Image21"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "After the user clicks the Add button, the Tasks panel disappears.",
        },
      ],
    },
    {
      id: 5,
      sections: [
        {
          id: 0,
          card: {
            transition: true,
            text: "Secure voting",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "0",
              x: "0",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: [""],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText: "",
        },
        {
          id: 2,
          card: {
            transition: false,
            text:
              "Attendees can securely cast votes on agenda items with the Decisions voting feature.",
            snack: {
              isVisible: true,
              position: "left",
            },
            position: {
              y: "83%",
              x: "50%",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["Decisions_Step5_Image1"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "Teams is open to the Calendar app under the meeting titled “Weekly leadership team meeting.” The Agenda tab is open and there is one agenda item card titled “CMO candidates.” The Agenda item card includes the title, description, associated team member, and more.",
        },
        {
          id: 3,
          card: {
            transition: false,
            text: "Choose the agenda item that will require a vote",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "39%",
              x: "50%",
            },
            beacon: {
              isVisible: false,
              position: "top",
            },
          },
          images: {
            name: ["Decisions_Step5_Image2"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            " In the same view, a purple box outlines the CMO candidates agenda item card.",
        },
        {
          id: 4,
          card: {
            transition: false,
            text: "Click the ellipses",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "39%",
              x: "83.7%",
            },
            beacon: {
              isVisible: true,
              position: "top",
            },
          },
          images: {
            name: ["Decisions_Step5_Image3"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "A purple pop-up highlights the ellipses in the bottom right-hand corner of the agenda item.",
        },
        {
          id: 5,
          card: {
            transition: false,
            text: "Select New decision",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "21%",
              x: "78.4%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["Decisions_Step5_Image4"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            " After the user clicks the ellipses, a drop-down appears with six options including “New section” and “Speaker list.” A purple pop-up highlights the New decision option.",
        },
        {
          id: 6,
          card: {
            transition: false,
            text: "Title the decision and include a description",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "36%",
              x: "32%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["Decisions_Step5_Image5"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "After the user clicks the New decision, a white pop-up appears titled “New Decision.” The pop-up includes a form with the fields titled “Agenda item, “Title,” and “Description.” The agenda item 1 – CMO Candidates is selected in the Agenda item field. There is a toggle at the bottom of the pop-up with options that reads “Proposed” and “Final.” There are also buttons in the bottom right-hand corner that read “Cancel” and “Save.” A purple pop-up highlights the Title field.",
        },
        {
          id: 7,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "44%",
              x: "33%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["Decisions_Step5_Image6"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "In the same view, the user types “Candidate 1” in the title field, and a purple pop-up highlights the Description field.",
        },
        {
          id: 8,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "84.5%",
              x: "69%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["Decisions_Step5_Image7"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "The user types “Jennifer Au” in the Description field. A purple pop-up highlights the Save button.",
        },
        {
          id: 9,
          card: {
            transition: false,
            text: "Add decisions to offer additional voting choices",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "48.2%",
              x: "27.8%",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["Decisions_Step5_Image8"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            " After the user clicks the Save button, the pop-up disappears. Under the CMO Candidates agenda item, a new card appears with a header that reads “Decisions.” At the top of the pop-up is a button that reads “+Add” and buttons that read “Votes: 3” and “Start vote.” Below the header, there is a white circle and text that reads “Candidate 1” and “Proposed.” Below that is the name of the candidate Jennifer Au. A purple pop-up points to the +Add button.",
        },
        {
          id: 10,
          card: {
            transition: false,
            text: "Click the ellipsis for each decision",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "52.4%",
              x: "82.9%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["Decisions_Step5_Image9"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "After the user clicks the +Add button, two additional rows appear listing the names of two additional candidates-Anthony Barnes and Sarah Smith. A purple pop-up points to an ellipsis in the first row.",
        },
        {
          id: 11,
          card: {
            transition: false,
            text: "Press the Start vote button",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "35.5%",
              x: "78.3%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["Decisions_Step5_Image10"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "After the user clicks the ellipsis, a drop-down appears with six options including “Start vote” and “Make final.” A purple pop-up points to the Start vote option.",
        },
        {
          id: 12,
          card: {
            transition: false,
            text: "Customize the voting anonymity using the drop down menu",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "33.3%",
              x: "82.6%",
            },
            beacon: {
              isVisible: false,
              position: "right",
            },
          },
          images: {
            name: ["Decisions_Step5_Image11"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            " After the user clicks the Start vote option, a panel appears from the right-hand side. The panel has a header that reads “Start vote” and a sub-header that reads “1 - CMO candidates.” Beneath that, the name of a candidate is listed along with a field titled “Voting anonymity” and four check boxes indicating different settings for the vote. A purple pop-up box outlines the Voting anonymity drop-down where the option “Open” is currently selected.",
        },
        {
          id: 13,
          card: {
            transition: false,
            text:
              "Determine if attendees will have the option to abstain from the vote",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "42%",
              x: "82.6%",
            },
            beacon: {
              isVisible: false,
              position: "right",
            },
          },
          images: {
            name: ["Decisions_Step5_Image12"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "In the same view, a purple box outlines text that reads “Allow blank votes (Abstain)” next to a check box.",
        },
        {
          id: 14,
          card: {
            transition: false,
            text:
              "Select the Teams option to share results in the Teams chat when voting has ended",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "52%",
              x: "82.5%",
            },
            beacon: {
              isVisible: false,
              position: "right",
            },
          },
          images: {
            name: ["Decisions_Step5_Image13"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            " In the same view, a purple box outlines the sub-header “Send notifications” and two check boxes with text that reads “Teams” and “Use Basic Link in Voting Post.”",
        },
        {
          id: 15,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "94%",
              x: "96%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["Decisions_Step5_Image14"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "In the same view, a purple pop-up highlights a blue button at the bottom of the panel that reads “Apply.”",
        },
        {
          id: 16,
          card: {
            transition: false,
            text: "Join the meeting",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "6%",
              x: "88.7%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["Decisions_Step5_Image15"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "After the user clicks the Apply button, the panel disappears. A purple pop-up points to the Join button at the top right-hand corner of the screen.",
        },
        {
          id: 17,
          card: {
            transition: false,
            text:
              "Click on the Decisions icon to open the in-meeting extension",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "1.3%",
              x: "77%",
            },
            beacon: {
              isVisible: true,
              position: "top",
            },
          },
          images: {
            name: ["Decisions_Step5_Image16"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "After the user clicks the Join button, a meeting view appears with a black background and two profile pictures of team members. A purple pop-up highlights the Decisions icon in the upper right-hand corner. ",
        },
        {
          id: 18,
          card: {
            transition: false,
            text: "Select the agenda item that requires a vote",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "18.7%",
              x: "82.9%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["Decisions_Step5_Image17"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "After the user clicks the Decisions icon, a black panel appears from the right-hand side with a header that reads “Agenda.” Beneath the header, there is information on the agenda item CMO candidates. A purple pop-up highlights the blue number 1 next to the agenda item name.",
        },
        {
          id: 18,
          card: {
            transition: false,
            text: "Navigate to the Votes tab",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "19%",
              x: "94%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["Decisions_Step5_Image18"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            " After the user clicks the number one, two tabs appears that read “Details” and “Votes.” The details tab is currently open and shows further information on the agenda item CMO candidates including a description. A purple pop-up points to the Votes tab.",
        },
        {
          id: 19,
          card: {
            transition: false,
            text: "Press Cast vote",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "29%",
              x: "83%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["Decisions_Step5_Image19"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "After a user clicks the Votes tab, the names of candidates appear along with links beneath each name that read “Cast vote,” “View results,” a zero with an up-arrow, and a zero with a down-arrow.  A purple pop-up highlights the Cast vote link underneath Jennifer Au’s name.",
        },
        {
          id: 20,
          card: {
            transition: false,
            text: "Choose an option",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "34.5%",
              x: "22.4%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["Decisions_Step5_Image20"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            " After the user clicks the Cast vote link, a black pop-up appears with a header that reads “Decisions” and sub-headers that read “Cast vote” and “1 - CMO Candidates.” The text “Candidate 1” is displayed and beneath that, Jennifer Au’s name. There are two options that can be selected that read “Yes” and “No.” A purple pop-up highlights the Yes option.",
        },
        {
          id: 21,
          card: {
            transition: false,
            text: "Press Vote",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "75%",
              x: "74.2%",
            },
            beacon: {
              isVisible: true,
              position: "top",
            },
          },
          images: {
            name: ["Decisions_Step5_Image21"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "After the user selects the Yes option, a purple pop-up highlights the Vote button in the bottom right-hand corner of the pop-up.",
        },
        {
          id: 22,
          card: {
            transition: false,
            text:
              "Attendees can press view results to see the outcome and will also receive a Teams notification with this information.",
            snack: {
              isVisible: true,
              position: "left",
            },
            position: {
              y: "81%",
              x: "50%",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["Decisions_Step5_Image23"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "The user has cast the vote, and the view has returned to the meeting screen.",
        },
        {
          id: 23,
          card: {
            transition: false,
            text:
              "Secure voting is also available in Teams channels, email, and in the Decisions web agenda experience.",
            snack: {
              isVisible: true,
              position: "left",
            },
            position: {
              y: "84%",
              x: "50%",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["Decisions_Step5_Image24"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText: "",
        },
      ],
    },
    {
      id: 6,
      sections: [
        {
          id: 0,
          card: {
            transition: true,
            text: "Getting started",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "0",
              x: "0",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: [""],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText: "",
        },
        {
          id: 1,
          card: {
            transition: false,
            text: "To get the Decisions app, head to the Teams store",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "90%",
              x: "0.8%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["Decisions_Step6_Image1"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "The Marketing channel on Teams appears. A purple pop-up points to the Apps icon in the bottom right-hand corner. ",
        },
        {
          id: 2,
          card: {
            transition: false,
            text: "Search for Decisions",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "13%",
              x: "10%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["Decisions_Step6_Image2"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "After the user clicks the Apps icon, a new view appears. The header reads “Get more done with apps!” and there are app icons and descriptions displayed in a grid style view. On the left-hand side there is a panel with a header that reads “Apps” and tabs including “All,” “Personal apps,” “Bots” and more. A purple pop-up points to a search bar under the “Apps” header.",
        },
        {
          id: 3,
          card: {
            transition: false,
            text: "Click the Decisions icon",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "13%",
              x: "25.1%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["Decisions_Step6_Image3"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            " In the same view, the user types “Decisions” into the search bar. The grid of apps filters accordingly. In the same view, a purple pop-up points to the Decisions app within the grid. ",
        },
        {
          id: 4,
          card: {
            transition: false,
            text: "Install the app and sign in",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "28%",
              x: "31.1%",
            },
            beacon: {
              isVisible: true,
              position: "top",
            },
          },
          images: {
            name: ["Decisions_Step6_Image4"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "In the same view, a white box appears with a header that reads “Decisions. and a YouTube video titled “Run the meeting.” A purple pop-up points to a blue button that reads “Add.”",
        },
        {
          id: 5,
          card: {
            transition: false,
            text:
              "Work with your Teams administrator to pin the app to the menu bar for the entire organization.",
            snack: {
              isVisible: true,
              position: "left",
            },
            position: {
              y: "83%",
              x: "50%",
            },
            beacon: {
              isVisible: false,
              position: "bottom",
            },
          },
          images: {
            name: ["Decisions_Step6_Image5"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText: "",
        },
      ],
    },
    {
      id: 7,
      sections: [
        {
          id: 0,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "0",
              x: "0",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["Decisions_Step7_endcard"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText: "",
        },
      ],
    },
  ],
};
